/**
 * postMessage helpers for the booking-funnel -> train-results widget bridge.
 *
 * Message protocol:
 *   { type: 'TRAIN_WIDGET_DONE', payload: see formatPayload.WidgetHostCallbackPayload }
 *   { type: 'TRAIN_WIDGET_CANCEL' }
 *
 * targetOrigin is '*' since the booking-funnel doesn't know its host's origin
 * at runtime and the payload contains no secrets. The host (train-results)
 * still validates `event.origin` on receive.
 */
import { buildWidgetPayload } from './formatPayload'

export const TRAIN_WIDGET_DONE = 'TRAIN_WIDGET_DONE'
export const TRAIN_WIDGET_CANCEL = 'TRAIN_WIDGET_CANCEL'

export const postWidgetCallback = (extra: Parameters<typeof buildWidgetPayload>[0] = {}): void => {
    try {
        const payload = buildWidgetPayload(extra)
        console.info('[widgetMode] cart callback payload', JSON.stringify(payload))
        window.parent?.postMessage({ type: TRAIN_WIDGET_DONE, payload }, '*')
    } catch (err) {
        console.error('[widgetMode] failed to post DONE message', err)
    }
}

export const postWidgetClose = (): void => {
    try {
        window.parent?.postMessage({ type: TRAIN_WIDGET_CANCEL }, '*')
    } catch (err) {
        console.error('[widgetMode] failed to post CANCEL message', err)
    }
}
